import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError, retry } from 'rxjs/operators';
import { User, UserModel } from '../models/user';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
  private paramsObject: any;

  private param: string;

  private currentUser: any;

  private base_url = "";

  constructor(private http: HttpClient, private authService: AuthService) {
    this.base_url = environment.base_url;
  }

  /**
   * Get all Users
   * @param none
   * @returns array of users : User[]
   */
  getAll() {
    return this.http.get<any[]>(`${this.base_url}/api/users`)
      .pipe(
        retry(2),
        map(result => {
          result['data'] = result['data'].filter(item => {
            if (item['attributes']['role'] !== 'driver') return item
          })
          return result['data']
        }),
        catchError(err => {
          return throwError(err)
        })
      );
  }

  updateUser(user: UserModel) {
    return this.http.put<any>(`${this.base_url}/api/users/${Number(user.data.id)}`, user)
      .pipe(
        retry(2),
        map(user => {
          return user['data']
        }),
        catchError(err => {
          return throwError(err)
        })
      );
  }

  patchUser(user: Partial<UserModel>, id?: any) {
    let user_id;
    if (id) {
      user_id = id
    }
    else {
      user_id = user.data.id
    }
    return this.http.patch<any>(`${this.base_url}/api/users/${Number(user_id)}`, user)
      .pipe(
        retry(2),
        map(user => {
          return user['data']
        }),
        catchError(err => {
          return throwError(err)
        })
      );
  }

  /**
   * Get User by ID
   * @param id
   * @type String
   * @returns object user : User
   */
  getById(id: number) {
    return this.http.get(`${this.base_url}/api/users/${id}`)
      .pipe(
        retry(2),
        map(user => {
          return user
        }),
        catchError(err => {
          return throwError(err)
        })
      );
  }
  /**
   * Register User method
   * POST
   * @param user
   * @type User
   * @returns id : Number
   */
  register(user) {
        return this.http.post(`${this.base_url}/api/users`, user)
      .pipe(
        retry(2),
        map(result => {
          if (result) return result;

        }),
        catchError(err => {
          //@ts-ignore
          let errors = [...err['error']['errors']]
          return throwError(errors);
        })
      )
  }

  /**
   *
   * @param user : User
   * @payload {username, password}
   * @returns {"token":<token>,"role":<userRole>,"id":<db_user_id>}
   */
  login(user: User) {
    return this.http.post(`${this.base_url}/authenticate`, user)
      .pipe(
        map(result => {
          if (result) return result;

        }),
        catchError(err => {
          return throwError(err);
        })
      )
  }

  getUserGroups() {
    return this.http.get(`${this.base_url}/api/authgroups`)
    .pipe(
      map(result => {
        if (result) return result;

      }),
      catchError(err => {
        return throwError(err);
      })
    )
  }

  getUserRoles() {
    return this.http.get(`${this.base_url}/api/authroles`)
    .pipe(
      map(result => {
        if (result) return result;

      }),
      catchError(err => {
        return throwError(err);
      })
    )
  }
}
